import { Navigate, Route, Routes } from "react-router-dom";
import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";

import { Layout } from "./components/Layout";
import { SignIn } from "./pages/SignIn";
import { Onboarding } from "./pages/Onboarding";
import { CalendarPage } from "./pages/Calendar";
import { SettingsPage } from "./pages/Settings";

export function App() {
  return (
    <>
      <UnauthenticatedTemplate>
        <SignIn />
      </UnauthenticatedTemplate>
      <AuthenticatedTemplate>
        <Layout>
          <Routes>
            <Route path="/" element={<Navigate to="/calendar" replace />} />
            <Route path="/onboarding" element={<Onboarding />} />
            <Route path="/calendar" element={<CalendarPage />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="*" element={<Navigate to="/calendar" replace />} />
          </Routes>
        </Layout>
      </AuthenticatedTemplate>
    </>
  );
}
